import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Box } from "@mui/material"

import { getProductionStepsExecutionsSelector, getProductionStepsProductionDaySelector, getPSEsSidebarNotificationCountsSelector, getSelectedPSEsSidebarMenuSelector } from "../../reducers/Production/ProductionSteps"
import ProductionStepExecutionsTableNew from "./ProductionStepExecutionsTableNew"
import PSEsSidebar from "./sidebar/PSEsSidebar"
import { formatPSEsToTiles } from "../../utils/tiles"
import { loadProductionStepsExecutions, loadSelectedSideBarMenu, loadUnpackingPSEsBySupplierItems, showProductionStepExecution } from "../../actions/ProductionSteps/ProductionStepExecutions"
import { EXECUTIONS_SCROLL_SX, PSES_SIDEBAR_MENUS_ENUM } from "../../utils/productionStepExecution"
import UnpackingPSEs from "./unpacking/UnpackingPSEs"
import PrintPSE from "./print/PrintPSE"

const sx = {
	root: {
		display: "flex",
		flexDirection: "row",
		height: "100%",
		minHeight: 0,
		paddingTop: "64px",
	},
	rightSide: {
		padding: "24px",
		display: "flex",
		flexDirection: "column",
		alignSelf: "stretch",
		flex: 1,
		gap: "32px",
		...EXECUTIONS_SCROLL_SX,
	}
}

const ProductionStepsRead = () => {
	const dispatch = useDispatch()
	const productionSteps = useSelector(getProductionStepsExecutionsSelector)
	const productionDay = useSelector(getProductionStepsProductionDaySelector)
	const notificationCounts = useSelector(getPSEsSidebarNotificationCountsSelector)

	const [PSETilesToDisplay, setProductionStepsToDisplay] = useState([])
	const [isSidebarExpanded, setIsSidebarExpanded] = useState(true)

	// Side panel state
	const selectedMenu = useSelector(getSelectedPSEsSidebarMenuSelector)
	// Format PSEs into tiles
	const [tiles, setTiles] = useState([])


	// Format PSEs into tiles
	useEffect(() => {
		const formatTiles = async () => {
			const formattedTiles = await formatPSEsToTiles(productionSteps, { withIngredients: false, withPlannerData: false, productionDay })
			setTiles(formattedTiles)
		}
		formatTiles()
	}, [productionSteps])

	useEffect(() => {
		if (selectedMenu === PSES_SIDEBAR_MENUS_ENUM.UNPACKING) return

		setProductionStepsToDisplay(tiles)
	}, [tiles, selectedMenu])

	const handleTileClick = (productionStepExecution) => {
		// Navigate to the production step execution detail page
		dispatch(showProductionStepExecution(productionStepExecution.objectId || productionStepExecution.id))
	}

	const handleSelectMenu = async (menuId) => {
		switch (menuId) {
			case PSES_SIDEBAR_MENUS_ENUM.UNPACKING:
				await dispatch(loadUnpackingPSEsBySupplierItems())
				break
			// Cooking is the default category loaded in page first load, so no need to pass any parameter
			case PSES_SIDEBAR_MENUS_ENUM.COOKING:
			case PSES_SIDEBAR_MENUS_ENUM.WEIGHING:
			case PSES_SIDEBAR_MENUS_ENUM.TASTING:
				await dispatch(loadProductionStepsExecutions(menuId))
				break
			default:
				break
		}
		dispatch(loadSelectedSideBarMenu(menuId))
	}

	const handleStatusTabChange = async (tab) => {
		dispatch(loadProductionStepsExecutions(selectedMenu, tab))
	}

	return (
		<Box sx={sx.root}>
			<PSEsSidebar
				selected={selectedMenu}
				onSelect={handleSelectMenu}
				notifications={notificationCounts}
				isExpanded={isSidebarExpanded}
				onToggleExpand={() => setIsSidebarExpanded(prev => !prev)}
			/>
			<Box sx={sx.rightSide}>
				{selectedMenu === PSES_SIDEBAR_MENUS_ENUM.UNPACKING
					? (
						<UnpackingPSEs />
					) : (
						<ProductionStepExecutionsTableNew
							renderPrint={(id) => productionSteps.find(pse => pse.objectId === id) && <PrintPSE pse={productionSteps.find(pse => pse.objectId === id)} sx={{ backgroundColor: "" }} />}
							PSETiles={PSETilesToDisplay}
							productionDay={productionDay}
							onTileClick={handleTileClick}
							onStatusChange={handleStatusTabChange}
							selectedMenu={selectedMenu}
							statusNotificationCounts={notificationCounts[selectedMenu]}
							isSidebarExpanded={isSidebarExpanded}
						/>
					)}
			</Box>
		</Box>
	)
}

export default ProductionStepsRead